"use client";
import React, { Suspense, lazy } from "react";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import LoadingSpinner from "@/components/LoadingSpinner";

// Lazy loading de componentes
const Header62 = lazy(() => import("@/components/contactos/Header62").then(m => ({ default: m.Header62 })));
const Contact14 = lazy(() => import("@/components/contactos/Contact14").then(m => ({ default: m.Contact14 })));
const Contact1 = lazy(() => import("@/components/contactos/Contact1").then(m => ({ default: m.Contact1 })));

export default function Page() {
  return (
    <div>
      <Navbar />
      
      <Suspense fallback={<LoadingSpinner text="Cargando página de contacto..." className="py-20" />}>
        <Header62 />
      </Suspense>
      
      <div className="min-h-screen bg-gray-50">
        <div className="py-12 md:py-16 lg:py-20">
          <div className="container mx-auto px-4">
            <div className="mb-12 text-center">
              <h1 className="mb-4 text-4xl font-bold md:text-5xl lg:text-6xl">
                Contacto
              </h1>
              <p className="mx-auto max-w-2xl text-lg text-gray-600">
                Estamos aquí para responder tus preguntas y ayudarte en todo lo que necesites.
                No dudes en contactarnos.
              </p>
            </div>
            
            <Suspense fallback={<LoadingSpinner text="Cargando formulario de contacto..." className="py-12" />}>
              <Contact14 />
            </Suspense>
            
            <Suspense fallback={<LoadingSpinner text="Cargando información de contacto..." className="py-12" />}>
              <Contact1 />
            </Suspense>
          </div>
        </div>
      </div>
      
      <Footer />
    </div>
  );
}
